import { LockKeyhole, Smartphone } from 'lucide-react'
import { useState, type FormEvent } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { defaultRouteFor, useAuth } from '../auth'

export function LoginPage() {
  const auth = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  if (auth.loading) return <div className="auth-loading">正在确认登录状态…</div>
  if (auth.user) return <Navigate to={auth.user.mustChangePassword ? '/change-password' : defaultRouteFor(auth.user)} replace />

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    setError('')
    setBusy(true)
    try {
      const user = await auth.login(phone, password)
      const requested = (location.state as { from?: string } | null)?.from
      navigate(user.mustChangePassword ? '/change-password' : requested || defaultRouteFor(user), { replace: true })
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : String(reason))
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="auth-page">
      <section className="auth-card">
        <div className="auth-brand"><span>熊</span><div><strong>杯具熊经营台账</strong><small>内部经营数据系统</small></div></div>
        <header><h1>登录账号</h1><p>使用管理员为你创建的手机号和密码。</p></header>
        {auth.setupRequired ? <div className="auth-warning">尚未创建管理员。请先在服务器执行 <code>manage_product_site_accounts.py create-admin --phone &lt;手机号&gt; --username &lt;用户名&gt;</code>。</div> : null}
        <form onSubmit={submit}>
          <label><span>手机号</span><div><Smartphone aria-hidden="true" /><input inputMode="numeric" autoComplete="username" value={phone} onChange={(event) => setPhone(event.target.value)} placeholder="11位手机号" required /></div></label>
          <label><span>密码</span><div><LockKeyhole aria-hidden="true" /><input type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="请输入密码" required /></div></label>
          {error ? <p className="auth-error" role="alert">{error}</p> : null}
          <button type="submit" disabled={busy || auth.setupRequired}>{busy ? '正在登录…' : '登录'}</button>
        </form>
        <footer>账号由公司管理员创建，不开放自助注册。</footer>
      </section>
    </main>
  )
}
